import {t} from 'i18next';
import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import Header from '../components/Header';
import {Main} from '../components/Layout';
import Loading from '../components/Loading';
import {Panel, PanelCol, PanelContainer, Triangle} from '../components/Panel';
import {fetchProject} from '../utils/api';
import Login from './Login';

import Picture from '../assets/images/picture-02.svg';
import PictureTriangle from '../assets/images/triangle.svg';
import axios from 'axios';
import Button from '../components/Button';
import ErrorPanel from '../components/ErrorPanel';

const Join = () => {
  const [client, setClient] = useState('');
  const [clientLogo, setClientLogo] = useState('');
  const [joinStatus, setJoinStatus] = useState<
    'archived' | 'error' | 'loading'
  >();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const {token} = useParams();

  useEffect(() => {
    if (token) {
      setJoinStatus('loading');
      const check = async () => {
        try {
          const response = await fetchProject(token);
          console.log({response});

          setClient(response.customer.name);
          setClientLogo(response.customer.logo);

          if (response.status === 'archived') {
            setJoinStatus('archived');
          } else {
            setJoinStatus(undefined);
          }
        } catch (err) {
          if (
            (axios.isAxiosError(err) && err.response?.status === 400) ||
            (axios.isAxiosError(err) && err.response?.status === 404)
          ) {
            setErrorMessage(t(err.response.data.message));
          } else {
            setErrorMessage(t('errors.project-not-exits'));
            throw err;
          }
          setJoinStatus('error');
        }
      };
      check();
    } else {
      setJoinStatus('error');
      setErrorMessage(t('errors.link-broken'));
    }
  }, [token]);

  const renderMain = () => {
    if (joinStatus === 'loading') {
      return <Loading />;
    }

    if (joinStatus === 'error') {
      return <ErrorPanel errorMessage={errorMessage || ''} />;
    }

    if (joinStatus === 'archived') {
      return (
        <PanelContainer>
          <Panel>
            <PanelCol>
              <Triangle src={PictureTriangle} alt="" />
              <img src={Picture} alt="" />
            </PanelCol>
            <PanelCol>
              <h1>{t('archived.title')}</h1>
              <p>{t('archived.subtitle')}</p>
              <Button>
                <a
                  href="https://game2value.it/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('archived.cta')}
                </a>
              </Button>
            </PanelCol>
          </Panel>
        </PanelContainer>
      );
    }

    return (
      <Login clientName={client} clientLogo={clientLogo} token={token || ''} />
    );
  };

  return (
    <>
      <Header clientLogo={clientLogo} clientName={client} />
      <Main>{renderMain()}</Main>
    </>
  );
};

export default Join;
